module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book_info_item"
  }, [_c('a', {
    attrs: {
      "href": 'http://writebookapi.dangdang.com/h5-share?bookid=' + _vm.content.bookId,
      "dd_name": "进入书单详情页"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.content.bookTitle))]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.content.bookAttachUrl),
      expression: "content.bookAttachUrl"
    }],
    staticClass: "p_img",
    attrs: {
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p_text"
  }, [_vm._v(_vm._s(_vm.content.bookContent))])]), _vm._v(" "), _c('div', {
    staticClass: "operate_div"
  }, [_c('span', {
    staticClass: "p_type"
  }, [_vm._v(_vm._s(_vm.content.bookTypeName))]), _vm._v(" "), _c('div', {
    staticClass: "p_operta"
  }, [_c('div', {
    staticClass: "p_op_div",
    class: {
      isLiked: _vm.isLiked
    },
    attrs: {
      "dd_name": "关注"
    },
    on: {
      "click": _vm.collect_product
    }
  }, [_c('span', {
    staticClass: "p_op_icon collect_icon"
  }), _vm._v(_vm._s(_vm.content.likeNum && _vm.content.likeNum > 0 ? _vm.content.likeNum : '关注'))]), _vm._v(" "), _c('a', {
    staticClass: "p_op_div",
    attrs: {
      "href": 'http://writebookapi.dangdang.com/h5-share?bookid=' + _vm.content.bookId,
      "dd_name": "进入书单详情页"
    }
  }, [_c('span', {
    staticClass: "p_op_icon reply_icon"
  }), _vm._v(_vm._s(_vm.content.commentNum && _vm.content.commentNum > 0 ? _vm.content.commentNum : '回复'))])])]), _vm._v(" "), _c('div', {
    staticClass: "p_updata_div"
  }, [_c('div', {
    staticClass: "p_time"
  }, [_vm._v(_vm._s(_vm.content.creationDate))]), _vm._v(" "), (_vm.is_self) ? _c('a', {
    staticClass: "p_updata",
    attrs: {
      "dd_name": "更新",
      "href": "http://writebookapi.dangdang.com/h5-upstatic"
    }
  }, [_vm._v("更新")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6473a158"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bookInfoItem.vue
// module id = 222
// module chunks = 3